// extracted by mini-css-extract-plugin
module.exports = {"social":"social-module--social--2XWn8","title":"social-module--title--1Nnqu typography-module--responsiveTitle1--1tLTC","root":"social-module--root--1Y1AS"};